import { Injectable, inject } from '@angular/core';
import { ISerializeObject } from '@df/api/request/request.service';
import { AdvancedCommerceConfigStore } from '@df/module-advanced-commerce';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';

@Injectable({ providedIn: 'root' })
export class LocalKlevuTrackService extends KlevuTrackService {
    protected enabledAc = !!inject(AdvancedCommerceConfigStore)?.config()?.enabled;

    protected override track(endpoint: KlevuSearch.ANALYTICS_ENDPOINTS, data: ISerializeObject): void {
        if (!this.enabledAc || endpoint !== KlevuSearch.ANALYTICS_ENDPOINTS.categoryProductView) {
            super.track(endpoint, data);
        }
    }
}
